// Port of api/fuel/app/classes/model/log/user/tag.php
import Model from 'offline/stream/model/base'
import Constants from 'offline/constants'

export default Model.extend({
	table: 'log_user_tag',
	prefix: 'log',
	key: 'log_id',
	fields: {
		log_id: Model.SCHEMA_KEY,
		log_date: Model.SCHEMA_DATE_CREATE,
		user_id: Model.SCHEMA_NUMBER,
		tag_id: Model.SCHEMA_NUMBER,
		log_context: Model.SCHEMA_NUMBER,
		log_initial_sync: Model.SCHEMA_NUMBER,
		log_tag_context: Model.SCHEMA_NUMBER,
		log_tag_text: Model.SCHEMA_TEXT,
		log_tag_colour: Model.SCHEMA_TEXT
	},
	methods: {
		get_type: function() { return Constants.LOG_TYPE_USER_TAG },
		to_array: function() {
			return {
				id: +this.get_id(),
				date: +this.get_date(),
				type: +this.get_type(),
				context: +this.get_context(),
				user: +this.get_user_id(),
				tag: +this.get_tag_id(),
				text: this.get_tag_text(),
				colour: this.get_tag_colour(),
				tagContext: +this.get_tag_context()
			}
		}
	}
})
